import React from 'react';
import { useEffect } from 'react';
import StructuredData from "../components/StructuredData";


function Blues() {
    useEffect(() => {
    document.title = "Blues Dance Classes in Berlin — Zane Payer";
  }, []);

    const bluesSchema = {
  "@context": "https://schema.org",
  "@type": "Course",
  "name": "Tuesday Blues Dance Classes",
  "description":
    "Beginner Blues dance classes in Berlin for complete beginners, beginner/intermediate dancers, and anyone wanting to build confidence in Blues dancing.",
  "provider": {
    "@type": "Person",
    "name": "Zane Payer",
    "url": "https://zane.dance"
  },
  "location": {
    "@type": "Place",
    "name": "Maxixe",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Berlin",
      "addressCountry": "DE"
    }
  },
  "courseMode": "onsite"
};

    const eventSchema = {
  "@context": "https://schema.org",
  "@type": "DanceEvent",
  "name": "6-Week Blues Dance Class Series",
  "description":
    "A six-week Blues dance class series exploring musicality, connection, movement, and the many textures of Blues dancing.",
  "startDate": "2026-10-08T19:30:00+02:00",
  "endDate": "2026-10-08T21:00:00+02:00",
  "eventStatus": "https://schema.org/EventScheduled",
  "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
  "location": {
    "@type": "Place",
    "name": "Klosterstraße 44",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Klosterstraße 44",
      "postalCode": "10179",
      "addressLocality": "Berlin",
      "addressCountry": "DE"
    }
  },
  "organizer": {
    "@type": "Person",
    "name": "Zane Payer",
    "url": "https://zane.dance"
  }
};



    return (
    <div>
        <StructuredData data={bluesSchema} />
        <StructuredData data={eventSchema} />
    <div className = 'Taffel'>
    <h2>New 6 week blues dance class series in Berlin</h2> 
    coming up!
    <br/>starting October 8th
    <br/>Thursdays 7:30pm
    <br/>Klosterstraße 44, 10179 Berlin, Germany
    <br/> 90€ for the series
    <br/>Drop-ins possible!(€18)<br/><br/><br/>
    
    <br/>Join Sabina and me for a six week Blues 
    dance series exploring musicality, 
    connection, movement, and many textures of Blues dancing.
    <br/>All infos and Registration can be found at: <a className = 'info' href = 'https://sabinablumauer.si/blues-dance/'>Sabinas website</a>

    </div>

    <div className = 'Taffel'>
       {/*  <h2>Newcomers Blues Workshp</h2> 19th and 20th of September
        <br/> 12-2pm 
        <br/>at  
        <a className='info' href='https://maxixe.de/tanzkurse/blues-tanzkurse-berlin/'> Maxixe.</a>
        in Kreuzberg (U-platz der Luftbrucke)
        <br/>
        <br/>
        <br/>
        Always loved Blues music but never knew that Blues music could be danced to? Your friends 
        are bugging you to learn blues dancing? You want a dance that is easy to get into, but will
        keep you captivated? This is the perfect workshop for you.<br/>
        <a className='info' href='https://maxixe.de/tanzkurse/blues-tanzkurse-berlin/'>
        Register here.</a>
        <br/>
        <br/> */}

        <h2>Tuesday Blues Dance classes</h2>
        Weekly beginner Blues dance classes take place 
        <br/>every Tuesday at <a className='info' href='https://maxixe.de/tanzkurse/blues-tanzkurse-berlin/'> Maxixe.</a>
        in Berlin, 
        <br/>starting September 22nd, 
        <br/>from 9pm to 10pm.
        <br/><br/><br/>
        The class is suitable for complete beginners, beginner/intermediate dancers, 
        and anyone who wants to build confidence in Blues dancing.
        Always loved Blues music but never knew that Blues music could be danced to? Your friends 
        are bugging you to learn blues dancing? You want a dance that is easy to get into, but will
        keep you captivated? 
    </div>

    <div className = 'Taffel'>
    <h2>Lovelite Blues</h2>
    Additionally I'm helping to organise the
    <a class = "info" href = "Facebook.com/sweetbluesberlin"> Lovelite </a>blues dance 
    socials and tasters. <br/>Fridays twice a month.
    <br/>Haasestraße 1, 10245
    <br/><br/>
    <h2>Blues dance practice group</h2>
    on 
    <a class = "info" href = "https://t.me/+B1gU02udh6oyZWNk"> telegram </a> and we meet
    about monthly to work collaboratively on concepts we're working on. If you have other ideas
    you are interested in give me a shout and let's make it happen.
    </div>

    <div className = 'Taffel'>
        <h2>Other Resources</h2>
        -Peter is holding regular class through the 
<a class = "info" href = "https://www.tu-sport.de/sportprogramm/kurse/?tx_dwzeh_courses%5Baction%5D=show&tx_dwzeh_courses%5BsportsDescription%5D=1449&cHash=7690ccd7193ef5ce660ec1ac79432335"> TU </a> 
    in Berlin. 
    <br/>-Vicki & Adamo have an online blues class series at
    <a class = "info" href = "thebluesroom.com"> the Blues Room.</a>
    <br />-There are many intelligent
    writers and researcher some of which are 
    <a class = "info" href = "https://obsidiantea.com/"> Grey Armstrong, </a> 
    Bobby White's
    <a class = "info" href = "https://swungover.wordpress.com/table-of-contents/archives-2/"> Blog </a> and
    <a class = "info" href = "https://https://www.youtube.com/@swungover.com/"> podcast, </a>
    <a class = "info" href = "https://www.pennyandlucas.com/blog/"> Penny & Lucas</a>
    </div>
    <div className = 'Taffel'>
        <h2>A few good books on Blues dancing are</h2>
        -Jookin' by Katrina Hazzard Gordon
        <br />-Steppin on the Blues by Jacqui Malone
        <br />-Stomping the Blues by Albert Murray 
    </div>
    </div>
    
    )
  }

  export default Blues